import React, { Component } from 'react';

class IconCategoryIssueDelete extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 28 28">
                <path
                    fill="#26A"
                    d="M18.84 17.28c-.46-.46-2.44-2.44-3.29-3.28.95-.94 3.23-3.21 3.27-3.25.04-.04.09-.09.12-.14.19-.24.27-.53.23-.82-.04-.29-.19-.56-.43-.74-.44-.34-1.06-.29-1.48.12l-.59.59-2.69 2.69c-.91-.95-3.18-3.22-3.22-3.25l-.1-.1a1.107 1.107 0 00-1.85.75c-.01.33.11.64.36.88.03.03 2.32 2.33 3.28 3.27-.82.81-2.68 2.67-3.26 3.25l-.09.1a1.092 1.092 0 00.46 1.77c.13.04.25.06.38.06.29 0 .57-.12.8-.36.12-.12 2.32-2.33 3.25-3.27.59.58 1.76 1.76 2.43 2.42l.26.26c.2.2.4.4.6.61.21.21.49.33.79.34h.01c.29 0 .57-.11.77-.31.22-.21.33-.49.34-.78 0-.3-.12-.59-.35-.81z"
                ></path>
                <path
                    fill="#26A"
                    fillRule="evenodd"
                    d="M13.99 2C20.62 1.99 26.01 7.37 26 14c0 6.64-5.35 11.99-11.99 12C7.38 26.01 1.99 20.63 2 13.99 2.01 7.36 7.36 2.01 13.99 2zm.02 2.39c-5.27-.01-9.6 4.3-9.62 9.6-.02 5.27 4.29 9.59 9.59 9.63 5.26.04 9.63-4.32 9.64-9.61 0-5.29-4.32-9.61-9.61-9.62z"
                    clipRule="evenodd"
                ></path>
            </svg>
        );
    }
}

export default IconCategoryIssueDelete;